import React from "react";
import "./OurJourney.css";
import parse from "html-react-parser";

const OurJourney = ({ about_us }) => {
  return (
    <div className="our-journey-section mt-5">
      <div className="journey-card">
        <h2 className="journey-title">ABOUT US</h2>
        <p className="journey-text">
          {typeof about_us?.content === "string" ? (
            parse(about_us.content)
          ) : (
            <p>No content available.</p>
          )}
        </p>
      </div>
    </div>
  );
};

export default OurJourney;
